import { render, staticRenderFns } from "./EcPaginate.vue?vue&type=template&id=02751ea4&scoped=true&"
import script from "./EcPaginate.vue?vue&type=script&lang=ts&"
export * from "./EcPaginate.vue?vue&type=script&lang=ts&"
import style0 from "./EcPaginate.vue?vue&type=style&index=0&id=02751ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02751ea4",
  null
  
)

export default component.exports